import { RootState } from '@global/store/store';

export const countryStoreSelector = (state: RootState) => state.country;
export const countriesSelector = (state: RootState) => state.country.countries;
